import { authEnum } from "@/config/auth";
import { authTokenAtom } from "@/recoil/authAtom";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";

export function useLogout() {
  const navigate = useNavigate();
  const setAuthTokenAtom = useSetRecoilState(authTokenAtom);
  const queryClient = useQueryClient();

  return () => {
    queryClient.clear();
    setAuthTokenAtom("");
    localStorage?.removeItem(authEnum.authToken);
    localStorage?.removeItem("siteId");

    fetch(`${process.env.REACT_APP_BASE_URL}/auth/logout`, {
      method: "POST", // HTTP 메소드 지정
      body: JSON.stringify({ username: localStorage.getItem("username") }),
      headers: {
        "Content-Type": "application/json", // 내용 유형을 JSON으로 설정
      },
    });

    navigate("/");
  };
}
